import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ProviderDetails, ProviderTypeList } from 'src/app/core/Models/interfaces/responseData';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { USER_TYPE } from 'src/app/core/Constants/static';
import { UserService } from 'src/app/core/Services/user.service';
import { UserDetails, UserProfile } from 'src/app/core/Models/interfaces/user-details';

@Component({
  selector: 'app-prov-view',
  templateUrl: './prov-view.component.html',
  styleUrls: ['./prov-view.component.css']
})
export class ProvViewComponent implements OnInit {
  @Input('providerId') providerId?: number | null;
  @Input('showDetails') showDetails?: boolean;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editProvider: EventEmitter<boolean> = new EventEmitter<boolean>();
  isAddProvider: boolean = false;
  showSlider: boolean = false;
  detailsList!: ProviderDetails;
  isLoader: boolean = false;
  regulatorList: any[] = [];
  copyText: string = 'copy';
  currencyList: any[] = [];
  regulatorObjt: any;
  billingCurrencyObj: any;
  serviceCode: any[] = [];
  countryObjt: any;
  stateObjt: any;
  cityObjt: any;
  stateList: any[] = [];
  cityList: any[] = [];
  user: UserProfile | null;
  showEdit: boolean = false;
  clientSecretMasked!:string
  dummyData = [
    {
      id: 1,
      name: 'ICD',
    },
    {
      id: 2,
      name: 'SDC',
    },
  ];
  ProvTypeObj: string='';
  specialityTypeObj: string='';

  // provType:ProviderTypeList[] = [];
  countryList: any[] = [];
  constructor(
    private provPayerApiService: ProvPayerApiService,
    private userService: UserService
  ) {
    this.user = this.userService.getUserInfo();
  }

  ngOnInit(): void {
    this.getMasterLists();
    if (this.user?.userDetails?.userType === USER_TYPE.provider) {
      this.showEdit = false;
    } else {
      this.showEdit = true;
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.showSlider = true;
    });
  }
  getMasterLists() {
    this.isLoader = true;
    forkJoin([
      this.provPayerApiService.getRegulatorList(),
      this.provPayerApiService.getCurrencyList(),
      this.provPayerApiService.getCountryList(),
      this.provPayerApiService.getEditProviderDetails(this.providerId),
    ]).subscribe({
      next: (responseList) => {
        this.regulatorList = responseList[0];
        this.currencyList = responseList[1];
        this.countryList = responseList[2];
        this.detailsList = responseList[3]?.data[0];
        if(this.detailsList?.client_secret){
          let first = this.detailsList?.client_secret?.slice(0, 2);
          let last = this.detailsList?.client_secret?.substr(this.detailsList?.client_secret.length - 2);
          this.clientSecretMasked = first + '************************' + last;
        }
        
        forkJoin([
          this.provPayerApiService.getStateList(Number(this.detailsList?.country)),
          this.provPayerApiService.getCityList(Number(this.detailsList?.region)),
        ]).subscribe({
          next: (res) => {
            this.stateList = res[0]?.data;
            this.cityList = res[1]?.data;
            this.getDetails();
            this.isLoader = false;
          }
        })
      }
    })
  }
  getDetails() {
    this.regulatorObjt = this.regulatorList?.find(el => el.regulatoryId == this.detailsList?.regulatorId);
    this.billingCurrencyObj = this.currencyList?.find(el => el.currencyId == this.detailsList?.billingCurrency);
    this.ProvTypeObj=this.detailsList?.provider_type.map(item=>item.providerType).join(', ')
    this.specialityTypeObj=this.detailsList?.speciality.map(item=>item.speciality).join(', ')

    this.countryObjt = this.countryList?.find(el => el.countryId == this.detailsList?.country);
    this.stateObjt = this.stateList?.find(el => el.regionId == this.detailsList?.region)
    this.dummyData.forEach((item: any) => {
      this.detailsList?.serviceCodeType.forEach((el: any) => {
        if (el == item?.id) {
          this.serviceCode.push(item?.name)
        }
      })
    });
  }
  showEditPopup() {
    this.editProvider.emit(true);
  }
  copyMessage(item?: any) {
    this.copyText = 'copied'
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = item;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  closePopup() {
    this.providerId = null;
    this.close.emit(false);
  }
}
